import { module } from 'angular';

import { CenterView, default as centerViewName } from './center-view.component.ajs';

export default module('contact.agent.center-view', []).component(centerViewName, new CenterView()).name;
